import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class HasFocusBinding implements ICustomBinding {

    public initBinding() {

        // Überschreibung von hasFocus
        let koHasFocusUpdateFunction = ko.bindingHandlers.hasfocus.update;

        ko.bindingHandlers.hasfocus.update = (element, valueAccessor, bindings, view, bindingContext) => {
            if ($(element).is(":visible")) {
                koHasFocusUpdateFunction(element, valueAccessor, bindings, view, bindingContext);
            }
        };
    }
}